
/*运行管理系统*/

/*主容器文件*/
const yxgl_ = () =>  import("../../../studio/sub_systems/yxgl_system/yxgl_system_main");

/*运行管理管理  首页子系统*/
const yxgl_index_ = () =>  import("../../../studio/sub_systems/yxgl_system/index_page/index_page_main");
/*运行管理管理  首页子系统 - 客户管理*/
const yxgl_index_khgl = () =>  import("../../../studio/sub_systems/yxgl_system/index_page/khgl/khgl_main");


export default [
  {
    path: '/yxglxt',
    name: '运行管理系统',
    redirect: '/yxglxt/index',
    component: yxgl_,
    children: [
      {
        path: '/yxglxt/index',
        redirect: '/yxglxt/index/khgl',
        name: '首页',
        component: yxgl_index_,
        children:[
          {
            path: '/yxglxt/index/khgl',
            name: '客户管理',
            component: yxgl_index_khgl ,
          },
        ]
      },

    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/yxgl/yxgl_system_page.js